import * as yup from 'yup';
import { getMinCharactersTextMessage, getRequiredTextMessage } from '../';
import { PAYMENT_METHODS } from 'src/constants/payments';
export const propertyInformationSchema = yup.object({
  propertyAddress: yup.string().min(2, getMinCharactersTextMessage('general.primary_property_address', 2)).required(getRequiredTextMessage('general.primary_property_address')),
  ownership: yup.string().min(2, getMinCharactersTextMessage('add_new_property_flow.ownership_entity', 2)).required(getRequiredTextMessage('add_new_property_flow.ownership_entity')),
  buildingSquare: yup.number().truncate().notRequired()
});
export const propertyInformationSchemaV2 = yup.object({
  propertyAddress: yup.string().min(2, getMinCharactersTextMessage('general.primary_property_address', 2)).required(getRequiredTextMessage('general.primary_property_address')),
  ownership: yup.string().min(2, getMinCharactersTextMessage('add_new_property_flow.ownership_entity', 2)).notRequired(),
  buildingSquare: yup.number().truncate().notRequired()
});
export const vacancyCostRecoveryInput = {
  vacancyCostRecovery: ''
};
export const vacancyCostRecoveryInputSchema = yup.object({
  vacancyCostRecovery: yup.number().required().moreThan(0)
});
export const utilitySetupNewCustomProvider = {
  name: '',
  website: ''
};
export const utilitySetupNewCustomProviderSchema = yup.object({
  name: yup.string().min(2, 'Name too short').required(getRequiredTextMessage('Provide Name')),
  website: yup.string().nullable().optional().min(3, 'Website url not valid')
  // .required(getRequiredTextMessage('Website')),
});
export const propertyPayoutDetailsInitVales = {
  paymentMethod: PAYMENT_METHODS.ACH,
  // ACH
  achDepositDataPaymentId: '',
  nameOnAccount: '',
  depositoryName: '',
  routingNumber: '',
  accountNumber: '',
  // Regular check
  regularCheckPaymentId: '',
  payeeName: '',
  payeeAddress: ''
};
export const propertyPayoutDetailsValidationScheme = yup.object().shape({
  // ACH
  nameOnAccount: yup.string().when('paymentMethod', {
    is: val => val === PAYMENT_METHODS.ACH && false,
    // Note disabled required LB-1801
    then: schema => schema.min(2, 'Name on account is too short').required(getRequiredTextMessage('Name on account')),
    otherwise: schema => schema.nullable().optional().min(2, 'Name on account is too short')
  }),
  depositoryName: yup.string().when('paymentMethod', {
    is: val => val === PAYMENT_METHODS.ACH && false,
    // Note disabled required LB-1801
    then: schema => schema.min(2, 'Depository Name too short').required(getRequiredTextMessage('Depository Name')),
    otherwise: schema => schema.nullable().optional().min(2, 'Depository Name too short')
  }),
  routingNumber: yup.string().when('paymentMethod', {
    is: val => val === PAYMENT_METHODS.ACH && false,
    // Note disabled required LB-1801
    then: schema => schema.test('len', 'Routing Number must be exactly 9 digits', val => (val === null || val === void 0 ? void 0 : val.length) === 9).required(getRequiredTextMessage('Routing Number')),
    otherwise: schema => schema.nullable().optional().test('len', 'Routing Number must be exactly 9 digits', val => val !== null && val !== void 0 && val.length ? val.length > 0 && val.length === 9 : true)
  }),
  accountNumber: yup.string().when('paymentMethod', {
    is: val => val === PAYMENT_METHODS.ACH && false,
    // Note disabled required LB-1801
    then: schema => schema.test('len', 'Account Number may be up to 17 digits long', val => (val === null || val === void 0 ? void 0 : val.length) <= 17).required(getRequiredTextMessage('Account Number')),
    otherwise: schema => schema.nullable().optional().test('len', 'Account Number may be up to 17 digits long', val => val !== null && val !== void 0 && val.length ? val.length > 0 && val.length <= 17 : true)
  }),
  // regular check
  payeeName: yup.string().when('paymentMethod', {
    is: val => val === PAYMENT_METHODS.RegularCheck,
    then: schema => schema.min(2, 'Payee Name too short').required('Payee Name is required'),
    otherwise: schema => schema.nullable().optional().min(2, 'Payee Name too short')
  }),
  payeeAddress: yup.string().when('paymentMethod', {
    is: val => val === PAYMENT_METHODS.RegularCheck,
    then: schema => schema.min(2, 'Payee Address too short').required('Payee Address is required'),
    otherwise: schema => schema.nullable().optional().min(2, 'Payee Name too short')
  })
});